import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Button, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IWarningModal } from "store/types/modals";

import { useActionHook, useModals } from "../../../hooks";

import "./WarningModal.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};

export const WarningModal: React.FC<{ data: IWarningModal | null }> = ({ data }) => {
  const { closeWarningModal, cancelWarningModal } = useModals();
  const defaultAction = async () => undefined;

  useActionHook(data?.action || defaultAction, {
    onFinally: closeWarningModal
  });

  const { action: handleCancel } = useActionHook(data?.cancelAction || defaultAction, {
    onFinally: cancelWarningModal
  });

  const closeButtonHandler = () => {
    if (data?.cancelAction) {
      cancelWarningModal();
      return;
    }

    closeWarningModal();
  };

  return (
    <Modal open={!!data} onClose={closeButtonHandler}>
      <Box sx={style}>
        <div className="warning-modal">
          <div className="warning-modal__head">
            <div className="warning-modal__title">
              <WarningAmberIcon />
              <span>WARNING</span>
            </div>
            <IconButton onClick={closeButtonHandler}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="warning-modal__body">
            <div className="warning-modal__body-message">{data?.msg}</div>
            <div>
              <Button onClick={closeWarningModal} variant="contained">
                {data?.onPressSuccess ?? "Ok"}
              </Button>

              {data?.cancelAction && (
                <Button onClick={handleCancel} variant="contained" className="warning-modal__body-cancel-button">
                  {data?.onPressCancel ?? "Cancel"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
